import {
    Button,
    Grid,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Typography,
} from "@mui/material";
import * as React from 'react'
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { LoadingButton } from "@mui/lab";
import { apiConstants, get, postGeneric } from "../../common/constants";
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import PageTitle from "../../components/PageTitle";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";

export default function UpdateB2COrder() {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false);
    const [fetching, setFetching] = React.useState(false);

    const UpdateOrderSchema = Yup.object().shape({
        merchant: Yup.string().required('Please select merchant'),
        codToPrepadEnabled: Yup.string().required('Please select an option'),
        codToPrepad: Yup.string().when('codToPrepadEnabled', {
            is: 'true',
            then: Yup.string().required('Amount is required when COD to Prepaid is enabled'),
            otherwise: Yup.string()
        })
    });

    const method = useForm({
        resolver: yupResolver(UpdateOrderSchema),
        defaultValues: {
            merchant: '',
            codToPrepadEnabled: '',
            codToPrepad: '',
            sendSMS: '',
            sendWhatsapp: ''
        },
    })

    const {
        handleSubmit,
        reset,
        watch,
        setValue,
    } = method;

    const selectedMerchant = watch('merchant');

    React.useEffect(() => {
        if (!selectedMerchant) return;
        setFetching(true);
        get(`${apiConstants.MERCHANT_CONFIG}/${selectedMerchant}`).then((res) => {
            const config = res?.data?.orderConversionCharges;
            if (config) {
                setValue('codToPrepadEnabled', config.codToPrepadEnabled === true ? 'true' : 'false');
                setValue('codToPrepad', config.codToPrepad != null ? String(config.codToPrepad) : '');
                setValue('sendSMS', config.sendSMS === true ? 'true' : config.sendSMS === false ? 'false' : '');
                setValue('sendWhatsapp', config.sendWhatsapp === true ? 'true' : config.sendWhatsapp === false ? 'false' : '');
            } else {
                setValue('codToPrepadEnabled', '');
                setValue('codToPrepad', '');
                setValue('sendSMS', '');
                setValue('sendWhatsapp', '');
            }
        }).catch(() => {
            enqueueSnackbar('Could not fetch existing config', { variant: 'warning' });
        }).finally(() => setFetching(false));
    }, [selectedMerchant, setValue, enqueueSnackbar]);


    const onSubmit = (data) => {
        setLoading(true)
        const payload = {
            "codToPrepadEnabled": data.codToPrepadEnabled,
            "codToPrepad": data.codToPrepad,
            // "prepadToCodEnabled": data.prepadToCodEnabled,
            // "prepadToCod": data.prepadToCod,
            "sendSMS": data.sendSMS,
            "sendWhatsapp": data.sendWhatsapp
        }
        // {
        //     "taskType": data.taskType,
        //     "awb_number": data.awb_number,
        // }
        // postGeneric(`${apiConstants.EDIT_B2C_ORDER}`, payload).then((res) => {
        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${data.merchant}/pricing/orderConversionCharges`, payload).then((res) => {
            enqueueSnackbar("Success", { variant: 'success' })
            reset()
        }).catch((err) => {
            console.log(err);
            enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
        }).finally(() => setLoading(false))
    }

    return (
        <>
            <PageTitle>Update B2C Order</PageTitle>
            <Card sx={{ pb: 5 }}>
                <CardHeader
                    title="Order Conversion Settings"
                    subheader="Configure settings for converting orders between COD and Prepaid payment methods"
                />
                <CardContent>
                    <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={4}>
                                <MerchantFilterCached />
                            </Grid>
                            {fetching && (
                                <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={18} />
                                    <Typography variant='body2' sx={{ opacity: 0.6 }}>Loading existing config…</Typography>
                                </Grid>
                            )}
                            <Grid item xs={4}>
                                <RHFSelectField width={'100%'} label="COD to Prepaid Enabled" name="codToPrepadEnabled" options={[{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]} />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <RHFSelectField width={'100%'} label="Prepaid to COD Enabled" name="prepadToCodEnabled" options={[{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]} />
                            </Grid> */}
                            <Grid item xs={4}>
                                <RHFTextField type="number" label="COD to Prepaid Amount" name="codToPrepad" />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <RHFTextField label="Prepaid to COD" name="prepadToCod" />
                            </Grid> */}
                            <Grid item xs={4}>
                                <RHFSelectField width={'100%'} label="Send SMS" name="sendSMS" options={[{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]} />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFSelectField width={'100%'} label="Send WhatsApp" name="sendWhatsapp" options={[{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]} />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <RHFSelectField
                                    width="100%"
                                    name="taskType"
                                    label={`Select Task Type *`}
                                    options={[{ value: 'COD_TO_PREPAID', label: 'COD to Prepaid' }]}
                                />
                            </Grid> */}
                            <Grid item xs={4}>
                                <LoadingButton variant="contained" size="small" type="submit" sx={{ mt: 1, borderRadius: 1 }} loading={loading}>Submit</LoadingButton>
                                <Button variant="contained" size="small" color='error' sx={{ ml: 1, mt: 1, borderRadius: 1 }} onClick={() => { reset() }}>Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    )
}